import { UserI } from "@Interfaces";
import { IProduct } from "@Interfaces/Api/Product";
import { ApiCore } from "@Services/API/Core";
import { apiProvider } from "@Services/API/Provider";

const url = "product";
const apiProduct = new ApiCore<IProduct>({
  getAll: true,
  getSingle: true,
  getSingleBySlug: true,
  remove: false,
  url: url,
  post: false,
  put: false,
  patch: false,
});
apiProduct.search = (name: any, page: any, perPage: any) => {
  return apiProvider.getAll(`${url}/search?name=${name}&page=${page}&perPage=${perPage}`);
};
export { apiProduct };
